// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/NewInputBorder.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}
:root {
  color-scheme: only light;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

h1{
  color: red;
}
.nav-bar{
  background-color: #282c34;
}
.nav-bar ul li{
  display: inline-block;
  text-decoration: none;
  padding: 15px;
}
.nav-bar ul li a{
  text-decoration: none;
  color: #fff;
  font-size: 18px;
}
.ContactParaInputInner input::placeholder,
.ContactParaInputInner input::-webkit-input-placeholder,
.ContactParaInputInner input:-ms-input-placeholder{ 
    border-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    border-image-repeat: stretch;
    border-image-slice: 14;
    border-image-width: 0 0 8px 0;
    border-image-outset: 0;
    border-style: solid;
    text-align: center;
    padding: 0 5px;
    font-style: italic;
    font-weight: 700;
    font-size: 28px;
    line-height: 65px;
    color: #0D5268;
    /* opacity: 0.5; */
}
.text-danger {
  font-weight: 700;
}
@media(min-width: 767px){
  .navbar{
    padding: 0 1rem;
  }
}





`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;;;IAGI,qDAAmD;IACnD,4BAA4B;IAC5B,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n:root {\n  color-scheme: only light;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nh1{\n  color: red;\n}\n.nav-bar{\n  background-color: #282c34;\n}\n.nav-bar ul li{\n  display: inline-block;\n  text-decoration: none;\n  padding: 15px;\n}\n.nav-bar ul li a{\n  text-decoration: none;\n  color: #fff;\n  font-size: 18px;\n}\n.ContactParaInputInner input::placeholder,\n.ContactParaInputInner input::-webkit-input-placeholder,\n.ContactParaInputInner input:-ms-input-placeholder{ \n    border-image: url(assets/images/NewInputBorder.png);\n    border-image-repeat: stretch;\n    border-image-slice: 14;\n    border-image-width: 0 0 8px 0;\n    border-image-outset: 0;\n    border-style: solid;\n    text-align: center;\n    padding: 0 5px;\n    font-style: italic;\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 65px;\n    color: #0D5268;\n    /* opacity: 0.5; */\n}\n.text-danger {\n  font-weight: 700;\n}\n@media(min-width: 767px){\n  .navbar{\n    padding: 0 1rem;\n  }\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
